

<script lang="ts">
  import type {
    WorkOrdersViewFrameContext,
    WorkOrderPageContext as PageContext,
  } from "../../context"
  import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
  import WorkOrderDetailsContent from "./_modules/work-order-details-content"
  import SchedulePlanningContent from "./_modules/schedule-planning-content"

  const { viewFrameContext, activeTab } = $props<{
    viewFrameContext: WorkOrdersViewFrameContext
    activeTab: string
  }>()

  const pageContext = $derived.by<PageContext>(() => ({
    organizationId: viewFrameContext.organizationId,
    organizationSlug: viewFrameContext.organizationSlug ?? null,
    workOrderId: viewFrameContext.workOrderId,
    workOrder: viewFrameContext.workOrder ?? null,
    reloadKey: viewFrameContext.reloadKey,
    subscriptionRestrictionActive: viewFrameContext.subscriptionRestrictionActive,
    onContextChange: viewFrameContext.onContextChange,
    permissions: viewFrameContext.permissions,
    currentUserId: viewFrameContext.currentUserId,
  }))
  const contentKey = $derived(
    `${pageContext.organizationId}:${pageContext.workOrderId}:${pageContext.reloadKey}`,
  )
</script>

{#key contentKey}
  {#if activeTab === "planning"}
    <SchedulePlanningContent {pageContext} {activeTab} />
  {:else}
    <WorkOrderDetailsContent {pageContext} />
  {/if}
{/key}
